import { ProfilePageConfig } from './profile/ProfilePageConfig';

export const UsersConfigs = [
    ProfilePageConfig,
];
